import type * as React from 'react';
import { del } from '@Domain/Api';
import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';
import invitationRevoked, {
	type InvitationRevokedAction,
} from '@Application/Users/Users/Actions/invitationRevoked';
import invitationRevocationFailed, {
	type InvitationRevocationFailedAction,
} from '@Application/Users/Users/Actions/invitationRevocationFailed';
import type RevokeInvitation from '@Application/Users/Users/Commands/RevokeInvitation';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = InvitationRevokedAction | InvitationRevocationFailedAction;

export default (command: RevokeInvitation) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await del<UserPayload>(
				`${parameters.api.host}/api/accounts/${command.accountId}/users/${command.userId}/invitation`,
			);

			const action = invitationRevoked(payload, command.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = invitationRevocationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
